/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { BlockPicker } from "react-color";
import { TextField } from "./TextField";
import { RefCallBack } from "react-hook-form";
import { css } from "@emotion/react";
import { colors } from "../../colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  errorMessage?: string;
  innerRef?: RefCallBack;
  helperText?: string;
  labelIcon?: React.ReactNode;
  onChange: (value: any) => void;
}

const wrapperStyle = css`
  position: relative;
  width: 100%;
`;

const blockPickerOuterWrapperStyle = css`
  position: absolute;
  z-index: 2;
`;

const blockPickerInnerWrapperStyle = css`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

export const ColorPickerField = ({ value, onChange, ...rest }: Props) => {
  const [displayPicker, setDisplayPicker] = useState(false);
  const colorPickWrapperStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 8px;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    border-radius: 4px;
    transform: translateY(-50%);
    top: 50%;
    margin: auto;
    background: ${colors.white};
    border: solid 1px ${colors.greyBorder};
  `;

  const colorPickerStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    border-radius: 2px;
    background: ${value as string};
  `;

  return (
    <div css={wrapperStyle}>
      <TextField
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
        floatingElement={
          <div
            css={colorPickWrapperStyle}
            onClick={() => setDisplayPicker(true)}
          >
            <div css={colorPickerStyle}>
              {!value && (
                <FontAwesomeIcon fontSize="12px" icon={solid("eye-dropper")} />
              )}
            </div>
          </div>
        }
        {...rest}
      />
      {displayPicker && (
        <div css={blockPickerOuterWrapperStyle}>
          <div
            css={blockPickerInnerWrapperStyle}
            onClick={() => setDisplayPicker(false)}
          />
          <BlockPicker
            onChangeComplete={(color) => onChange(color.hex)}
            color={value as string}
          />
        </div>
      )}
    </div>
  );
};
